import React, { useState, useEffect, useRef } from "react";
import { Loader } from "../../components";
import classNames from "classnames";


export default function EmbedContainer(props) {
  const { src, title } = props;
  const [isLoaded, setIsLoaded] = useState(false);
  const [iframeHeight, setIframeHeight] = useState(1200);
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  
  useEffect(() => {
    if (!iframeRef.current) return;
    
    iframeRef.current.style.height = `${iframeHeight}px`;
  
    let handleResize;
    if (src && src.includes('paperform.co')) {
      const isMobile = window.innerWidth < 768;
      
      if (isMobile) {
        setIframeHeight(6200); // Mobile height
        if (iframeRef.current) {
          iframeRef.current.style.height = '6200px';
        }
      } else {
        setIframeHeight(4000); // Desktop height
        if (iframeRef.current) {
          iframeRef.current.style.height = '4000px';
        }
      }
      
      // Define the resize handler
      handleResize = () => {
        const isMobileNow = window.innerWidth < 768;
        if (isMobileNow && iframeHeight !== 6200) {
          setIframeHeight(6200);
          if (iframeRef.current) {
            iframeRef.current.style.height = '6200px';
          }
        } else if (!isMobileNow && iframeHeight !== 4000) {
          setIframeHeight(4000);
          if (iframeRef.current) {
            iframeRef.current.style.height = '4000px';
          }
        }
      };
      
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (handleResize) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [src, iframeHeight]);

  return (
    <div ref={containerRef} className="flex flex-col flex-grow">
      {!isLoaded && (
        <div className="mx-auto my-12">
          <Loader />
        </div>
      )}

      <iframe
        ref={iframeRef}
        className={classNames(
          isLoaded ? "flex flex-grow" : "hidden",
          "w-full"
        )}
        style={{ height: `${iframeHeight}px` }}
        src={src}
        title={title}
        onLoad={() => {
          setIsLoaded(true);
        }}
        allow="camera; microphone; autoplay; encrypted-media; fullscreen"
      />
    </div>
  );
}
